import React, { useState } from "react";

interface TooltipProps {
    text: string;
    children: React.ReactNode;
}

const Tooltip: React.FC<TooltipProps> = ({ text, children }) => {
    const [visible, setVisible] = useState(false);

    return (
        <div
            className="relative inline-block"
            onMouseEnter={() => setVisible(true)}
            onMouseLeave={() => setVisible(false)}
            onClick={() => setVisible(!visible)}
        >
            {children}
            <div
                className={`absolute -right-3.5 md:absolute-center -top-9 md:!top-[-15px] z-0 px-3 py-2 text-sm border border-gray-200 text-gray-700 bg-white rounded-lg shadow-lg transition-opacity duration-200 whitespace-nowrap
          ${visible ? "opacity-100 w-fit" : "opacity-0 w-fit pointer-events-none"}`}
            >
        <span className="block break-words text-center">
          {text}
        </span>
                <div
                    className="absolute z-30 w-3 h-3 rotate-45 bg-white border-b border-r border-gray-200
          -bottom-3 right-3 lg:left-1/2 -translate-x-1/2 -translate-y-1/2"
                ></div>
            </div>
        </div>
    );
};

export default Tooltip;
